module.exports = __webpack_public_path__ + "static/img/lv1.d5b3548b.webp";